import React from 'react'

import { usePdfOptionsForm } from '../../../components/pdf/options/_form/PdfOptionsFormHandler'
import ChildrenRepliesSection from './replies/ChildrenRepliesSection'
import DocumentHeader from './general/documentHeader/DocumentHeader'
import ServiceOrderHeader from './general/ServiceOrderHeader'
import RepliesSection from './replies/RepliesSection'
import Page from '../../../components/pdf/Page'
import Overview from './general/Overview'

const PdfDocument = ({ serviceOrder, categories, counters, childrenServiceOrders }) => {
  const form = usePdfOptionsForm()
  return (
    <Page>
      <DocumentHeader />
      <ServiceOrderHeader serviceOrder={serviceOrder} counters={counters} />
      <Overview serviceOrder={serviceOrder} />
      <RepliesSection serviceOrder={serviceOrder} categories={categories} />
      {!form.hideChildrenServiceOrders &&
        childrenServiceOrders.map(serviceOrder => (
          <ChildrenRepliesSection key={serviceOrder.id} serviceOrder={serviceOrder} />
        ))}
    </Page>
  )
}

export default PdfDocument
